export enum Exchange {
  Binance = 'BINANCE',
  KuCoin = 'KUCOIN',
  MexC = 'MEXC',
  Coinbase = 'COINBASE',
}
